"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CV_pdf_1 = __importDefault(require("../../assets/CV.pdf"));
var styles_1 = require("./styles");
var Avatar = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Character, null,
            react_1.default.createElement(styles_1.PaperSheet, null,
                react_1.default.createElement("div", null, "Gloria Luzio"),
                react_1.default.createElement(styles_1.Line, { width: 110 }),
                react_1.default.createElement(styles_1.Line, { width: 50 }),
                react_1.default.createElement(styles_1.Line, { width: 80 }),
                react_1.default.createElement(styles_1.Line, { width: 60 }),
                react_1.default.createElement(styles_1.Line, { width: 100 }),
                react_1.default.createElement(styles_1.CV, { href: CV_pdf_1.default, target: "_blank" },
                    react_1.default.createElement(styles_1.DownloadContainer, null,
                        react_1.default.createElement(styles_1.Arrow, null)),
                    react_1.default.createElement("div", null, "Mon CV "))))));
};
exports.default = Avatar;
